<app-nav-header></app-nav-header>
<div class="wrapper">
    <div class="main">
        <div id="solutionsPage">
            <div class="bannerArea">
                <div class="bannerBox">
                    <div class="wordBox">
                        <h1>{{ 'solutions.title' | translate }}</h1>
                        <h2>
                            {{ 'solutions.subtitle' | translate }}
                        </h2>
                    </div>
                </div>
            </div>

            <div class="overallAreaAbove">
                <div class="overallAboveBox">
                    <div class="imgBox">
                        <img
                            [src]="getHeroWheelImage()"
                            alt="" />
                    </div>
                    <div class="introBox">
                        <div class="paragraphBox">
                            <h2>{{ 'solutions.successfulCase' | translate }}</h2>
                            <p>
                                {{ 'solutions.content.first' | translate }}
                            </p>
                            <p class="introLastWord">
                                {{ 'solutions.content.second' | translate }}
                            </p>
                        </div>
                    </div>
                </div>
            </div>

            <div class="overallArea">
                <div class="overallBox">
                    <div class="collageBox">
                        <div
                            class="solutionCard solutionGridCard"
                            (click)="goToSolutionExplore('investForensics')">
                            <ng-container
                                *ngTemplateOutlet="investForensicsTpl"></ng-container>
                        </div>
                        <div
                            class="solutionCard solutionGridCard"
                            (click)="goToSolutionExplore('securityMonitor')">
                            <ng-container
                                *ngTemplateOutlet="securityMonitorTpl"></ng-container>
                        </div>
                        <div
                            class="solutionCard solutionGridCard"
                            (click)="goToSolutionExplore('intelGovern')">
                            <ng-container
                                *ngTemplateOutlet="intelGovernTpl"></ng-container>
                        </div>
                        <div
                            class="solutionCard solutionGridCard"
                            (click)="goToSolutionExplore('logisticsTransport')">
                            <ng-container
                                *ngTemplateOutlet="logisticsTransportTpl"></ng-container>
                        </div>
                        <div
                            class="solutionCard solutionGridCard"
                            (click)="goToSolutionExplore('coreOpsHR')">
                            <ng-container
                            *ngTemplateOutlet="coreOpsHRTpl"></ng-container>
                    </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<app-footer></app-footer>

<!-- ** 解決方案 -->
<ng-template #investForensicsTpl>
    <img
        src="/assets/images/indexPage/solution-invest.jpg"
        alt="" />
    <div class="strip">
        <span>{{ 'solutions.names.techInvestigationDigitalForensics' | translate }}</span>
        <p>{{ 'solutions.contents.techInvestigationDigitalForensics' | translate }}</p>
    </div>
</ng-template>

<ng-template #securityMonitorTpl>
    <img
        src="/assets/images/indexPage/solution-security.jpg"
        alt="" />
    <div class="strip">
        <span>{{ 'solutions.names.smartSecurityFieldMonitoring' | translate }}</span>
        <p>{{ 'solutions.contents.smartSecurityFieldMonitoring' | translate }}</p>
    </div>
</ng-template>

<ng-template #intelGovernTpl>
    <img
        src="/assets/images/indexPage/solution-intel.jpg"
        alt="" />
    <div class="strip">
        <span>{{ 'solutions.names.intelIntegrationSmartGovernance' | translate }}</span>
        <p>{{ 'solutions.contents.intelIntegrationSmartGovernance' | translate }}</p>
    </div>
</ng-template>

<ng-template #logisticsTransportTpl>
    <img
        src="/assets/images/indexPage/solution-logistics.jpg"
        alt="" />
    <div class="strip">
        <span>{{ 'solutions.names.smartLogisticsTransportMgmt' | translate }}</span>
        <p>{{ 'solutions.contents.smartLogisticsTransportMgmt' | translate }}</p>
    </div>
</ng-template>

<ng-template #coreOpsHRTpl>
    <img
        src="/assets/images/indexPage/solution-core.jpg"
        alt="" />
    <div class="strip">
        <span>{{ 'solutions.names.coreOpsHRManagement' | translate }}</span>
        <p>{{ 'solutions.contents.coreOpsHRManagement' | translate }}</p>
    </div>
</ng-template>